import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBlocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.1074 4.10744C0.866494 7.34835 0.866494 12.6517 4.1074 15.8926C7.34831 19.1335 12.6516 19.1335 15.8925 15.8926C19.1334 12.6517 19.1334 7.34835 15.8925 4.10744C12.6516 0.866537 7.34831 0.866537 4.1074 4.10744ZM14.1247 7.05372L7.05368 14.1248L5.87517 12.9463L12.9462 5.87521L14.1247 7.05372Z",
		fill: "#DC3616"
	})
});
export default SvgIconBlocked;
